/*
Cls - class of dataset detector, such as HumanEntry, DetectorBeltEntry from models/criticalDataset
field - field instance in the models/criticalDataset/CriticalDatasetEntry.js
 */

export default (Cls, field) => ({
  props: {
    isFilter: Boolean
  },
  data: () => ({
    filters: (new Cls()).filters(),
    datasetField: field
  }),
  methods: {
    filterValueChanged (isToggled, detectorField) {
      this.$emit('filter-value-changed', {
        datasetField: this.datasetField,
        detectorField,
        isToggled
      })
    }
  }
})
